import cx from "classnames"

export interface NumberCardProps {
  number: number
  heading: string
  text: string
  className?: string
}

const NumberCard = ({ number, heading, text, className }: NumberCardProps) => (
  <div
    className={cx("flex flex-col bg-grass-50 rounded-[6px] p-4", className)}
    data-testid="number-card"
  >
    <span className="bg-grass-300 flex items-center justify-center w-9 h-9 text-lg font-body font-bold leading-[130%] rounded-full">
      {number}
    </span>

    <h4 className="text-charcoal-500 font-body font-bold leading-[140%] tracking-[0.32px] mt-3">
      {heading}
    </h4>

    <p className="text-charcoal-500 text-xs leading-[140%] tracking-[0.36px] mt-[6px]">
      {text}
    </p>
  </div>
)

export default NumberCard
